(function($) {

	$.fn.singleLinkForm = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.singleLinkForm.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            $this.find('a').click(function(){
                $this.submit();
                return false;
            });
        });
	};

})(jQuery);